(() => {
  const initNamglory = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = document.querySelectorAll('.ng-reveal:not(.is-visible)');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      reveals.forEach((element) => observer.observe(element));
    } else {
      reveals.forEach((element) => element.classList.add('is-visible'));
    }

    document.querySelectorAll('.ng-sticky-buy').forEach((bar) => {
      const mainButton = document.querySelector('.product-form__submit');
      if (!mainButton || !('IntersectionObserver' in window)) {
        bar.classList.add('is-visible');
        return;
      }

      const buyObserver = new IntersectionObserver(
        ([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.05 }
      );
      buyObserver.observe(mainButton);
    });

    document.querySelectorAll('[data-ng-counter]:not([data-ng-counter-ready])').forEach((counter) => {
      counter.dataset.ngCounterReady = 'true';
      const target = Number(counter.dataset.ngCounter || 0);

      if (reduceMotion || !('IntersectionObserver' in window)) {
        counter.textContent = target;
        return;
      }

      const counterObserver = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          const startedAt = performance.now();
          const duration = 900;
          const tick = (now) => {
            const progress = Math.min((now - startedAt) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            counter.textContent = Math.round(target * eased);
            if (progress < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
          counterObserver.disconnect();
        },
        { threshold: 0.45 }
      );
      counterObserver.observe(counter);
    });

    if (!reduceMotion && !document.documentElement.dataset.ngParallaxReady) {
      document.documentElement.dataset.ngParallaxReady = 'true';
      let scheduled = false;
      const updateParallax = () => {
        document.querySelectorAll('.ng-parallax').forEach((element) => {
          const rect = element.getBoundingClientRect();
          const viewportCenter = window.innerHeight / 2;
          const elementCenter = rect.top + rect.height / 2;
          const ratio = Math.max(-1, Math.min(1, (elementCenter - viewportCenter) / window.innerHeight));
          element.style.setProperty('--ng-parallax-y', `${ratio * -18}px`);
        });
        scheduled = false;
      };
      const requestParallax = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(updateParallax);
      };
      window.addEventListener('scroll', requestParallax, { passive: true });
      window.addEventListener('resize', requestParallax);
      requestParallax();
    }
  };

  document.addEventListener('DOMContentLoaded', initNamglory);
  document.addEventListener('shopify:section:load', initNamglory);
})();
